import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetTopology2gRequest = (userId, tech, bands, coordinates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Map/GetTopology`,
	data: { userId, tech, bands, coordinates }
});

export const GetTopology3gRequest = (userId, tech, bands, coordinates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Map/GetTopology`,
	data: { userId, tech, bands, coordinates }
});

export const GetTopology4gRequest = (userId, tech, bands, coordinates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Map/GetTopology`,
	data: { userId, tech, bands, coordinates }
});

export const GetTopologyLabels2gRequest = (userId, tech, bands, coordinates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Map/GetTopologyLabels`,
	data: { userId, tech, bands, coordinates }
});

export const GetTopologyLabels3gRequest = (userId, tech, bands, coordinates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Map/GetTopologyLabels`,
	data: { userId, tech, bands, coordinates }
});

export const GetTopologyLabels4gRequest = (userId, tech, bands, coordinates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Map/GetTopologyLabels`,
	data: { userId, tech, bands, coordinates }
});

export const GetSitesIdsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Map/GetSitesIds`,
});

export const GetSiteIdLocationRequest = (siteId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Map/GetSiteIdLocation`,
	params: { siteId }
});
